module.exports = __webpack_public_path__ + "img/skull_2_bj.911c5daf.png";